const Hamburger = ({ loc }) => {
  const handleHamburger = () => {
    // Get elements by class name
    let sideNavElements = document.getElementsByClassName("sidenav");
    let rightSideElements = document.getElementsByClassName("right-side");

    // Check if there are elements with the specified class
    if (sideNavElements.length > 0) {
      // Access the first element in the collection and toggle the class
      sideNavElements[0].classList.toggle("open");
    }

    if (rightSideElements.length > 0) {
      // Access the first element in the collection and toggle the class
      rightSideElements[0].classList.toggle("right-side-open");
    }
  };
  return (
    <>
      {((loc.pathname.split("/")[1] !== "auditForms" ||
        loc.pathname.split("/")[1] !== "audits" ||
        loc.pathname.split("/")[1] === "escalations") &&
        !loc.pathname.split("/")[2]) ||
      ((loc.pathname.split("/")[1] === "users" ||
        loc.pathname.split("/")[1] === "roles" ||
        loc.pathname.split("/")[1] === "forms" ||
        loc.pathname.split("/")[1] === "feedback-requests") &&
        loc.pathname.split("/")[2]) ? (
        <>
          <div className="hamburger" onClick={handleHamburger}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default Hamburger;
